<template>
	<div class="sing-up _modal">
		<div class="_modal-overlay" @click.self="$emit('close')"></div>
		<div class="sing-up__inner _modal-inner">
			<div class="sing-up__close _modal-close" @click="$emit('close')"></div>
			<div class="sing-up__content">
				<div class="sing-up__weapon sing-up__weapon_1 _ibg-contain">
					<img src="@/assets/images/bg/login/01.png" />
				</div>
				<div class="sing-up__login">
					<div class="sing-up__title _h2">
						{{ $t('create new account') }}
					</div>
					<div class="sing-up__form">
						<button
							class="sing-up__steam _btn-primary"
							@click="redirectToSteamAuth"
						>
							<span class="sing-up__steam-icon _ibg-contain">
								<img src="@/assets/images/icons/steam.png" />
							</span>
							<span>{{ $t('signup with steam') }}</span>
						</button>
						<div class="sing-up__label">{{ $t('or ') }}</div>
						<BaseInput
							class="sing-up__input"
							v-model="email"
							type="email"
							autocomplete="email"
							:label="`${$t('Email')}:`"
						/>
						<BaseInput
							class="sing-up__input"
							v-model="pass"
							type="password"
							:label="`${$t('Password')}:`"
						/>
						<BaseInput
							class="sing-up__input"
							v-model="passConfirm"
							type="password"
							:label="`${$t('Confirm Password')}:`"
						/>
						<BaseTermCheckbox v-model="terms" class="sing-up__checkbox">
							{{ $t('By Signing Up I agree with') }}
							<router-link
								v-if="termsPage?.slug"
								:to="{
									name: 'TextPage',
									params: { slug: termsPage.slug },
								}"
								target="_blank"
							>
								{{ termsPage.title }}
							</router-link>
							<template v-if="termsPage?.slug && privacyPage?.slug">
								<span>{{ ' ' + $t('and') + ' ' }}</span>
								<router-link
									:to="{
										name: 'TextPage',
										params: { slug: privacyPage.slug },
									}"
									target="_blank"
								>
									{{ privacyPage.title }}
								</router-link>
							</template>
						</BaseTermCheckbox>
						<Transition>
							<div v-if="error" class="sing-up__error">
								{{ error }}
							</div>
						</Transition>
						<button
							:disabled="
								!requiredRegisterFieldsAreFilled || loaderIsVisible
							"
							@click="submitRegister"
							class="sing-up__submit _btn-primary"
						>
							<span v-if="loaderIsVisible"
								>{{ $t('Registrating') }}...</span
							>
							<span v-else>{{ $t('Register') }}</span>
						</button>
					</div>
				</div>
				<div class="sing-up__weapon sing-up__weapon_2 _ibg-contain">
					<img src="@/assets/images/bg/login/02.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput.vue';
import { PRIVACY_PAGE, TERMS_PAGE } from '@/store/modules/staticPages';
import { mapGetters } from 'vuex';
import BaseTermCheckbox from '../base/BaseTermCheckbox.vue';

export default {
	name: 'SigninPage',
	components: { BaseInput, BaseTermCheckbox },
	props: {
		error: {
			type: String,
			required: true,
		},
		loaderIsVisible: {
			type: Boolean,
			required: true,
		},
	},
	data: function () {
		return {
			email: '',
			pass: '',
			passConfirm: '',
			terms: false,
		};
	},
	computed: {
		...mapGetters('staticPages', ['getTermsPage', 'getPrivacyPage']),
		termsPage() {
			return this.getTermsPage;
		},
		privacyPage() {
			return this.getPrivacyPage;
		},
		requiredRegisterFieldsAreFilled() {
			let fieldsAreFilled;
			if (this.email && this.pass && this.passConfirm && this.terms) {
				fieldsAreFilled = true;
			} else {
				fieldsAreFilled = false;
			}
			return fieldsAreFilled;
		},
	},
	created() {
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
	},
	mounted() {},
	watch: {},
	methods: {
		redirectToSteamAuth() {
			window.location.href = `${process.env.VUE_APP_DOMAIN}auth/steam/redirect`;
		},
		submitRegister() {
			let regData = {
				name: 'Name',
				surname: 'Surname',
				email: this.email,
				password: this.pass,
				passConfirm: this.passConfirm,
			};
			this.$emit('registration', regData);
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.sing-up {
	&__inner {
		@include adaptiveValue('padding-top', 60, 40);
		@media (min-width: $md2) and (min-height: 767.98px) {
			max-height: 100%;
			overflow: hidden;
			padding-left: 70px;
			padding-right: 70px;
			max-width: 1100px;
			background-color: transparent;
		}
		@media (max-width: $md2) {
			overflow-x: hidden;
		}
		@media (max-height: 767.98px) {
			max-width: 800px;
			overflow-x: hidden;
		}
	}
	&__close {
		@media (min-width: $md2) and (min-height: 767.98px) {
			right: 85px;
		}
	}
	&__content {
		position: relative;
		display: flex;
		gap: 20px;
		@media (min-width: $md3) and (min-height: 767.98px) {
			position: relative;
			&::before {
				z-index: -1;
				content: '';
				position: absolute;
				@include adaptiveValue('top', -60, -25);
				left: 0px;
				@include adaptiveValue('height', 60, 25);
				width: 100%;
				background: #080b0c;
				border-top-left-radius: var(--border-radius-primary);
				border-top-right-radius: var(--border-radius-primary);
				overflow: hidden;
			}
		}
	}
	&__login {
		flex: 1 1 100%;
		background: #080b0c;

		@media (min-width: $md3) and (min-height: 767.98px) {
			@include adaptiveValue('padding-bottom', 60, 25);
			border-bottom-left-radius: var(--border-radius-primary);
			border-bottom-right-radius: var(--border-radius-primary);
			min-height: 600px;
		}
		@media (max-width: $md3) {
			border-radius: var(--border-radius-primary);
		}
		@media (max-height: 767.98px) {
			border-radius: var(--border-radius-primary);
		}
	}
	&__weapon {
		position: absolute;
		max-width: 330px;
		@include adaptiveValue('max-width', 330, 230, 1470, 992, 1);
		width: 100%;
		padding-bottom: 30%;
		align-self: center;
		transform: translate(0px, -50%);
		&_1 {
			left: -10%;
			top: 50%;
		}
		&_2 {
			right: -10%;
			top: 80%;
		}
		@media (max-width: $md3) {
			@include hide-item;
		}
		@media (max-height: 767.98px) {
			@include hide-item;
		}
	}
	&__forgot {
		display: flex;
		flex-direction: column;
		.sing-up__form {
			margin: auto;
		}
	}
	&__title {
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__steam {
		margin-left: auto;
		margin-right: auto;
		display: flex;
		align-items: center;
		gap: 8px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
		span {
			position: relative;
			z-index: 1;
		}
		&::before {
			z-index: 0;
		}
		&-icon {
			min-width: 20px;
			height: 20px;
		}
	}
	&__label {
		color: var(--secondary-color);
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__form {
		width: 100%;
		max-width: 386px;
		margin: 0 auto;
	}
	&__input {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 16, 10);
		}
	}
	&__link {
	}
	&__text {
		color: var(--primary-color);
		font-weight: 500;
		font-size: 16px;
	}
	&__checkbox {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
	}
	&__link-up {
	}
	&__error {
		font-family: var(--font-family-inter);
		font-size: 16px;
		line-height: 120%;
		font-weight: 500;
		display: block;
		text-align: center;
		margin-bottom: 8px;
	}
	&__error {
		color: var(--error-color);
	}
	&__submit {
		min-width: 125px;
		margin: 0 auto;
		span {
			position: relative;
			z-index: 1;
		}
		&::before {
			z-index: 0;
		}
	}
}
</style>
